// Code generated by go run pkg/apigen/generate. DO NOT EDIT.

import useSWR, { SWRConfiguration, SWRResponse } from "swr";

import * as enums from "~src/shared/enums";
import * as routerTypes from "~src/public/apigen/types";
import * as globalTypes from "~src/shared/apigen/types";
import { fetchRPCRoute } from "~src/shared/apigen/framework";
import { FieldValidationError, RPCError, IRPCErrorOptions } from "~src/shared/errors/taxonomy";

export type IPublicSignInRequest = {
  name: string;
};

export type IPublicSignInReturn = Record<string, never>;

export const publicSignIn = async (
  args: IPublicSignInRequest,
): Promise<IPublicSignInReturn> => {
  return await fetchRPCRoute({
    method: "POST",
    router: "public",
    routePath: "SignIn",
    args,
    errors: [
    ],
  });
};

export const usePublicSignIn = (
  args: IPublicSignInRequest,
  config?: SWRConfiguration & {
    // If true, the hook will not fetch. Data will be null.
    blockFetch?: boolean,
    // This value will be included in the cache key. Pass different values to force cache
    // invalidation.
    refetchNonce?: number | string,
  },
): SWRResponse<IPublicSignInReturn, RPCError> => {
  return useSWR(
    config?.blockFetch === true ? null : ["/public/SignIn", args, config?.refetchNonce],
    async (_, _args) => await publicSignIn(_args),
    config,
  );
};
